import axios from "axios";
import axiosInstance from "../../../../setup/axios/SetupAxios";
const API_URL = process.env.REACT_APP_BASE_URL;

export const COUNTRY_LIST_URL = `${API_URL}/api/v1/countries`;
export const TIMEZONEID_LIST_URL = `${API_URL}/api/v1/timezone`;
export const TIMESUPERVISION_DATA_URL = `${API_URL}/api/v1/parent/time-supervision`;
export const KEYSTROKE_APPS_URL = `${API_URL}/api/v1/parent/keystroke-apps`;
export const NOTIFICATION_SETTING_URL = `${API_URL}/api/v1/parent/notification-setting`;
export const VIDEO_MONITOR_URL = `${API_URL}/api/v1/parent/video-nudity-monitor`;
export const DEFAULT_PARAMETER_URL = `${API_URL}/api/v1/parent/default-parameter`;
export const SCREENSHOT_SETTINGS_URL = `${API_URL}/api/v1/parent/screenshot-setting`;
export const APP_KEYSTROKES_SETTINGS_URL = `${API_URL}/api/v1/parent/app-keystroke-status`;
export const SETUP_WIZARD_URL = `${API_URL}/api/v1/parent/setup-wizard`;
export const KEYSTROKE_STATUS_URL = `${API_URL}/api/v1/parent/keystroke-status`;

export function getCountryList(translation_id) {
    return axios({
        url: COUNTRY_LIST_URL,
        method: "GET",
        params: { translation_id }
    })
}
  
export function getTimezoneList() {
    return axios({
        url: TIMEZONEID_LIST_URL,
        method: "GET"
    })
}

export function setTimeSupervision(payload) {
    return axiosInstance({
        url: TIMESUPERVISION_DATA_URL,
        method: "POST",
        data: payload
    })
}

export function getKeyStrokes(payload) {
    payload['pageOffset'] = 1;
    payload['pageLimit'] = 1000;
    return axiosInstance({
        url: KEYSTROKE_APPS_URL,
        method: "GET",
        params: payload
    })
}

export function setNotificationSetting(payload) {
    return axiosInstance({
        url: NOTIFICATION_SETTING_URL,
        method: "PUT",
        data: payload
    })
}

export function videoNudityMonitor(payload) {
    return axiosInstance({
        url: VIDEO_MONITOR_URL,
        method: "PUT",
        data: payload
    })
}

export function defaultParameter(payload) {
    return axiosInstance({
        url: DEFAULT_PARAMETER_URL,
        method: "GET",
        params: payload
    })
}

export function screenshotSettings(payload) {
    return axiosInstance({
        url: SCREENSHOT_SETTINGS_URL,
        method: "POST",
        data: payload
    })
}

export function appKeyStrokesStatus(payload) {
    return axiosInstance({
        url: APP_KEYSTROKES_SETTINGS_URL,
        method: "PUT",
        data: payload
    })
}

export function setupWizardSetup(payload) {
    return axiosInstance({
        url: SETUP_WIZARD_URL,
        method: "PUT",
        data: payload
    })
}

export function setRulesKeystrokeStatus(payload) {
    return axiosInstance({
        url: KEYSTROKE_STATUS_URL,
        method: "PUT",
        data: {
            IsActivate: payload?.activate,
            deviceId: payload?.deviceId,
            is_enable_supervision: payload?.isEnableSupervision,
            is_keystroke_keywords: payload?.isKeystrokeKeywords,
            is_load_default_settings: payload?.isLoadDefaultSettings,
            kidId: payload?.kidId
        }
    })
}